<template>
  <!-- 本地 Agent 能力标注:只在雨见浏览器内置了 pi 时由父组件渲染,悬停/聚焦显示介绍 -->
  <span class="agent-badge" tabindex="0" aria-describedby="agent-badge-tip">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="m7 9 3 3-3 3M13 15h4"/></svg>
    Agent
    <span id="agent-badge-tip" class="agent-badge-tip" role="tooltip">
      <strong>本地 Agent 已就绪</strong>
      <span>简单问题照常由我直接回答;需要动手的复杂任务，会自动交给浏览器内置的 Agent 在你的电脑上执行，例如:</span>
      <ul>
        <li>整理、转换、批量生成文件(Word、Excel、Markdown、图片等)</li>
        <li>写代码并运行验证、分析数据并输出结果</li>
        <li>跨多个网页查资料并汇总成报告，或在网站上完成多步操作</li>
      </ul>
      <span class="agent-badge-note">在问题里写明文件夹(如 E:\work\demo)就在那里工作，否则结果保存在浏览器数据目录的 workspaces 下。读写其它文件夹、执行命令前都会先询问你。用内置模型每天 300 次;选了自己的模型时直接用你的模型，不占额度。</span>
    </span>
  </span>
</template>

<script>
export default { name: 'LocalAgentBadge' };
</script>

<style scoped>
.agent-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  margin-left: 6px;
  padding: 0 8px;
  border-radius: 11px;
  font-size: 11px;
  font-weight: 600;
  color: #0f8a5f;
  background: rgba(16, 163, 110, 0.1);
  cursor: default;
  outline: none;
  flex: none;
}
.agent-badge-tip {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1000;
  width: 280px;
  max-width: calc(100vw - 32px);
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: #333;
  background: #fff;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  gap: 6px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.15s, transform 0.15s, visibility 0.15s;
  pointer-events: none;
}
.agent-badge:hover .agent-badge-tip,
.agent-badge:focus .agent-badge-tip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.agent-badge-tip strong {
  font-size: 13px;
  color: #0f8a5f;
}
.agent-badge-tip ul {
  margin: 0;
  padding-left: 18px;
}
.agent-badge-note {
  color: #888;
}
[data-theme="dark"] .agent-badge {
  color: #4cd6a0;
  background: rgba(76, 214, 160, 0.14);
}
[data-theme="dark"] .agent-badge-tip {
  color: #ddd;
  background: #2c2c2e;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
}
[data-theme="dark"] .agent-badge-tip strong {
  color: #4cd6a0;
}
[data-theme="dark"] .agent-badge-note {
  color: #999;
}
</style>
